<template>
  <HeroSection />
  <main id="main">
    <ClientLogos />

    <!-- Services on alt background -->
    <div class="section-bg-alt">
      <ServicesSection />
    </div>

    <!-- Wave: alt-bg → default bg (WhyUs) -->
    <WaveDivider fillClass="fill-surface" />

    <WhyUsSection />
    <SolutionsSection />

    <!-- Wave: default bg → alt bg (CaseStudies) -->
    <WaveDivider :flip="true" fillClass="fill-bg-alt" />

    <!-- CaseStudies on alt background -->
    <div class="section-bg-alt">
      <CaseStudiesSection />
    </div>

    <!-- Wave: alt-bg → default bg (FAQ) -->
    <WaveDivider fillClass="fill-bg" />

    <FaqSection />
    <CtaContactSection />
  </main>
</template>

<script setup>
import HeroSection from '@/components/HeroSection.vue';
import ClientLogos from '@/components/ClientLogos.vue';
import ServicesSection from '@/components/ServicesSection.vue';
import WhyUsSection from '@/components/WhyUsSection.vue';
import SolutionsSection from '@/components/SolutionsSection.vue';
import CaseStudiesSection from '@/components/CaseStudiesSection.vue';
import FaqSection from '@/components/FaqSection.vue';
import CtaContactSection from '@/components/CtaContactSection.vue';
import WaveDivider from '@/components/WaveDivider.vue';
</script>

<style>
/* Not scoped intentionally — .fill-* classes are applied to child SVG elements
   inside WaveDivider (cross-component), so scoping would break them. */
.fill-bg-alt {
  fill: var(--color-bg-alt);
}
.fill-surface {
  fill: var(--color-surface);
}
.fill-bg {
  fill: var(--color-bg);
}
</style>
